
  import { Vue, Component, Prop } from "vue-property-decorator";

  @Component
  export default class BudgetRange extends Vue {
    @Prop({ type: Number, default: undefined }) readonly minBudget?: number;
    @Prop({ type: Number, default: undefined }) readonly maxBudget?: number;

    get budget(): string {
      if (this.minBudget && this.maxBudget) {
        return `$${this.minBudget} - $${this.maxBudget}`;
      }

      if (this.minBudget) {
        return `$${this.minBudget}`;
      }

      if (this.maxBudget) {
        return `$${this.maxBudget}`;
      }

      return "-";
    }

  }
